import SelectButton from 'components/atoms/select_button';
import moment from 'moment';
import React from 'react';
import { NotificationProgressData } from 'store/modules/management_store/types';

interface DataTableItem {
  id: number;
  edital: string;
  created_at: string;
  title: string;
  publicBodyName: string;
  read: boolean;
  bidding_id: number;
  task_id: number;
  currentCompany: number;
  isChecked: boolean;
}

const ICON_GROW = 0;
const CREATED_AT_GROW = 1;
const EDITAL_GROW = 1;
const TITLE_GROW = 1;
const PUBLIC_BODY_GROW = 3;
const BUTTON_GROW = 1;
const SELECT_GROW = 0;

export const datatableData = (
  notificationProgressList: Array<NotificationProgressData>,
  currentCompany: number,
  selectedProgress: Array<number>,
) => {
  return notificationProgressList.map((notification_progress) => {
    const isChecked = selectedProgress.includes(notification_progress.id);
    return {
      id: notification_progress.id,
      edital: notification_progress.bidding?.edital,
      created_at: notification_progress.created_at,
      title: notification_progress?.progress?.title || '',
      publicBodyName: notification_progress.bidding?.public_body?.nome,
      read: notification_progress.read,
      bidding_id: notification_progress.bidding_id,
      task_id: notification_progress.task_id,
      currentCompany,
      isChecked,
    };
  });
};

export const datatableColumns = (
  setSelectedNotificationProgressId: React.Dispatch<React.SetStateAction<number>>,
  toggleSelected: (id: number) => void,
) => {
  return [
    {
      name: '',
      width: '80px',
      sortable: true,
      selector: (data: DataTableItem) => data.id,
      center: true,
      grow: SELECT_GROW,
      cell: (data: DataTableItem) => (
        <div
          className="databalloon"
          aria-label={data.isChecked ? 'Remover da seleção' : 'Selecionar licitação'}
          data-balloon-pos="right"
        >
          <SelectButton
            id={data.id}
            isChecked={data.isChecked}
            toggleSelected={toggleSelected}
            text=""
          />
        </div>
      ),
    },
    {
      name: '',
      width: '45px',
      sortable: true,
      selector: (data: DataTableItem) => data.id,
      center: true,
      grow: ICON_GROW,
      cell: (data: DataTableItem) => (
        <div className="d-flex flex-column">
          {data.read ? (
            <span className="material-icons">drafts</span>
          ) : (
            <span className="material-icons">email</span>
          )}
        </div>
      ),
    },
    {
      name: 'Data',
      sortable: true,
      selector: (data: DataTableItem) => data.created_at,
      ignoreRowClick: true,
      grow: CREATED_AT_GROW,
      cell: (data: DataTableItem) => (
        <div className={`${data.read ? '' : 'font-weight-bold'}`}>
          {moment(data.created_at).format('DD/MM/YYYY HH:mm')}
        </div>
      ),
    },
    {
      name: 'Edital',
      sortable: true,
      grow: EDITAL_GROW,
      selector: (data: DataTableItem) => data.edital,
      cell: (data: DataTableItem) => (
        <div className="text-center">
          <button
            type="button"
            className={`btn btn-link p-0 ${data.read ? '' : 'font-weight-bold'}`}
            onClick={() =>
              window.open(
                `/minhas_licitacoes/management/${data.bidding_id}/${data.currentCompany}`,
                `management`,
              )
            }
          >
            {data.edital}
          </button>
        </div>
      ),
    },
    {
      name: 'Órgão',
      wrap: true,
      sortable: true,
      grow: PUBLIC_BODY_GROW,
      selector: (data: DataTableItem) => data.publicBodyName,
      cell: (data: DataTableItem) => (
        <div className={`m-0 ${data.read ? '' : 'font-weight-bold'}`}>{data.publicBodyName}</div>
      ),
    },
    {
      name: 'Andamento',
      sortable: true,
      selector: (data: DataTableItem) => data.title,
      wrap: true,
      grow: TITLE_GROW,
      cell: (data: DataTableItem) => (
        <div className={`${data.read ? '' : 'font-weight-bold'}`}>{data.title}</div>
      ),
    },
    {
      name: '',
      center: true,
      allowOverflow: true,
      grow: BUTTON_GROW,
      cell: (data: DataTableItem) => (
        <button
          type="button"
          className="btn btn-sm btn-primary text-white"
          onClick={() => setSelectedNotificationProgressId(data.id)}
        >
          Visualizar
        </button>
      ),
    },
  ];
};
